import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { LocLabel } from '../components/clickable-row-table/models/data-table-config.models';
import { LocalizationHelper } from '../helpers/localization.helper';
import { LocalizationService } from './localization.service';

const duration = 3000;
@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  private locHelper = new LocalizationHelper(this.ls);
  constructor(
    private matSnackBar: MatSnackBar,
    private ls: LocalizationService
  ) {}

  /**
   * Translate string key or LocLabel object
   * Translation value from string key is capitalized after translation
   */
  private translate(data: string | LocLabel): string {
    return typeof data === 'string' ? StrHlp.capitalize(this.ls.translate(data)) : this.locHelper.locLabel(data);
  }

  public showSuccess(messageKey: string | LocLabel, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.matSnackBar.open(this.translate(messageKey), action, { duration, panelClass: 'success-toast' });
  }
  public showError(messageKey: string | LocLabel, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.matSnackBar.open(this.translate(messageKey), action, { duration, panelClass: 'error-toast' });
  }
  public showInfo(messageKey: string | LocLabel, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.matSnackBar.open(this.translate(messageKey), action, { duration });
  }
  public showWarn(messageKey: string | LocLabel, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.matSnackBar.open(this.translate(messageKey), action, { duration, panelClass: 'warn-toast' });
  }
}
